import * as types from '../constants/actionTypes';
import foldersService from '../services/foldersService';

import Folder from '../models/Folder';

export const addConversationToFolderRequest = params => ({
  type: types.ADD_CONVERSATION_TO_FOLDER_REQUEST,
  params,
});

export const addConversationToFolderFailure = payload => ({
  type: types.ADD_CONVERSATION_TO_FOLDER_FAILURE,
  payload,
});

export const addConversationToFolderSuccess = payload => ({
  type: types.ADD_CONVERSATION_TO_FOLDER_SUCCESS,
  payload,
});

export const removeConversationFromFolderRequest = params => ({
  type: types.REMOVE_CONVERSATION_FROM_FOLDER_REQUEST,
  params,
});

export const removeConversationFromFolderFailure = payload => ({
  type: types.REMOVE_CONVERSATION_FROM_FOLDER_FAILURE,
  payload,
});

export const removeConversationFromFolderSuccess = payload => ({
  type: types.REMOVE_CONVERSATION_FROM_FOLDER_SUCCESS,
  payload,
});

export const updateFolderRequest = params => ({
  type: types.UPDATE_FOLDER_REQUEST,
  params,
});

export const updateFolderFailure = payload => ({
  type: types.UPDATE_FOLDER_FAILURE,
  payload,
});

export const updateFolderSuccess = payload => ({
  type: types.UPDATE_FOLDER_SUCCESS,
  payload,
});

export const deleteFolderRequest = params => ({
  type: types.DELETE_FOLDER_REQUEST,
  params,
});

export const deleteFolderFailure = payload => ({
  type: types.DELETE_FOLDER_FAILURE,
  payload,
});

export const deleteFolderSuccess = payload => ({
  type: types.DELETE_FOLDER_SUCCESS,
  payload,
});

export const createFolderRequest = params => ({
  type: types.CREATE_FOLDER_REQUEST,
  params,
});

export const createFolderFailure = payload => ({
  type: types.CREATE_FOLDER_FAILURE,
  payload,
});

export const createFolderSuccess = payload => ({
  type: types.CREATE_FOLDER_SUCCESS,
  payload,
});

export const getFoldersRequest = params => ({
  type: types.GET_FOLDERS_REQUEST,
  params,
});

export const getFoldersFailure = payload => ({
  type: types.GET_FOLDERS_FAILURE,
  payload,
});

export const getFoldersSuccess = payload => ({
  type: types.GET_FOLDERS_SUCCESS,
  payload,
});

export const addOrRemoveSingleConversationToMultipleFolderRequest = params => ({
  type: types.ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_REQUEST,
  params,
});

export const addOrRemoveSingleConversationToMultipleFolderFailure = payload => ({
  type: types.ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_FAILURE,
  payload,
});

export const addOrRemoveSingleConversationToMultipleFolderSuccess = payload => ({
  type: types.ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_SUCCESS,
  payload,
});

export function selectFolderSuccess(folder) {
  return { type: types.SELECT_FOLDER_SUCCESS, folder };
}

// get folders
export const getFolders = (params, callback) => dispatch => {
  dispatch(getFoldersRequest());
  return foldersService
    .getFolders(params)
    .then(res => {
      if (res.success) {
        if (callback) {
          callback();
        }
        return dispatch(
          getFoldersSuccess({
            data: res.data,
            items: res.data.items.map(item => new Folder(item)),
          })
        );
      }

      return dispatch(getFoldersFailure());
    })
    .catch(() => dispatch(getFoldersFailure()));
};

// We don't used that one any more, please using addConversationToFolder and removeConversationFromFolder instead
// folders should be looking like this [{ folderId: 0, action: 'remove|add' }]
// export const addOrRemoveSinggleConversationToMultipleFolder = ({ conversationId, folders }, callback) => dispatch => {
//   dispatch(addOrRemoveSingleConversationToMultipleFolderRequest());
//   // TO DO CALL API TO ADD/REMOVE SINGLE CONVERSATION TO MULTIPLE FOLDER
//   return foldersService.addOrRemoveSinggleConversationToMultipleFolder(conversationId, folders)
//     .then(res => {
//       if (res.success) {
//         callback && callback();
//         return dispatch(addOrRemoveSingleConversationToMultipleFolderSuccess());
//       }
//       return dispatch(addOrRemoveSingleConversationToMultipleFolderFailure());
//     })
//     .catch(() => dispatch(addOrRemoveSingleConversationToMultipleFolderFailure()));
// };

// create Single Folder
export const createFolder = (params, callback) => dispatch => {
  dispatch(createFolderRequest());
  return foldersService
    .createFolder(params)
    .then(res => {
      if (res.success) {
        if (callback) {
          callback();
        }
        dispatch(createFolderSuccess({ item: new Folder(res.data.items[0]) }));
      } else {
        dispatch(createFolderFailure());
      }
      return res;
    })
    .catch(error => {
      dispatch(createFolderFailure());
      throw error;
    });
};

// create Single Folder
export const updateFolder = (id, params, callback) => dispatch => {
  dispatch(updateFolderRequest());
  return foldersService
    .updateFolder(id, params)
    .then(res => {
      if (res.success) {
        if (callback) {
          callback();
        }
        dispatch(updateFolderSuccess({ item: new Folder(res.data.items[0]) }));
      } else {
        dispatch(updateFolderFailure());
      }
      return res;
    })
    .catch(error => {
      dispatch(updateFolderFailure());
      throw error;
    });
};

export const deleteFolder = (id, callback) => dispatch => {
  dispatch(deleteFolderRequest());
  return foldersService
    .deleteFolder(id)
    .then(res => {
      if (res.success) {
        if (callback) {
          callback();
        }
        dispatch(deleteFolderSuccess({ id }));
      } else {
        dispatch(deleteFolderFailure());
      }
      return res;
    })
    .catch(error => {
      dispatch(deleteFolderFailure());
      throw error;
    });
};

export const addConversationToFolder =
  ({ conversationId, folderId, isGroup, isInboxRetention }, callback) =>
  dispatch => {
    dispatch(addConversationToFolderRequest());
    return foldersService
      .addConversationToFolder(conversationId, folderId, isGroup, isInboxRetention)
      .then(res => {
        if (res.success) {
          if (callback) {
            callback();
          }
          dispatch(addConversationToFolderSuccess({ conversationId, folderId, isInboxRetention }));
        } else {
          dispatch(addConversationToFolderFailure());
        }
        return res;
      })
      .catch(error => {
        dispatch(addConversationToFolderFailure());
        throw error;
      });
  };

export const removeConversationFromFolder =
  ({ conversationId, folderId, isGroup = false }, callback) =>
  dispatch => {
    dispatch(removeConversationFromFolderRequest());
    return foldersService
      .removeConversationFromFolder(conversationId, folderId, isGroup)
      .then(res => {
        if (res.success) {
          if (callback) {
            callback();
          }
          dispatch(removeConversationFromFolderSuccess({ conversationId, folderId }));
        } else {
          dispatch(removeConversationFromFolderFailure());
        }
        return res;
      })
      .catch(error => {
        dispatch(removeConversationFromFolderFailure());
        throw error;
      });
  };
